import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const TermeniConditii = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      
      <main className="flex-grow pt-24 pb-16 bg-muted/30">
        <div className="container mx-auto px-4 sm:px-6 max-w-4xl">
          <h1 className="text-4xl sm:text-5xl font-bold text-primary mb-8 font-playfair">
            Termeni și Condiții
          </h1>
          
          <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground font-lora">
            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">1. Informații Generale</h2>
              <p>Prezentul document reglementează termenii și condițiile de utilizare a site-ului idaco.ro, operat de S.C. IDACO S.R.L., CIF: RO14053218, Nr. Reg. Comerțului: J23/501/2001.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">2. Acceptarea Termenilor</h2>
              <p>Prin accesarea și utilizarea acestui site, acceptați să respectați și să fiți obligat de acești termeni și condiții.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">3. Produse și Servicii</h2>
              <p>Toate produsele prezentate pe site sunt realizate manual și pot prezenta variații naturale în culoare, textură și finisaj. Produsele unicat sunt create la comandă și nu pot fi returnate.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">4. Comenzi și Plăți</h2>
              <p>Comenzile sunt procesate după confirmarea disponibilității produselor. Acceptăm plata ramburs și transfer bancar. Pentru produse personalizate, este necesar un avans de 50%.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">5. Livrare</h2>
              <p>Livrarea se face prin curier în toată țara. Termenul de livrare este de 3-7 zile lucrătoare pentru produsele din stoc și 14-30 zile pentru produsele la comandă.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">6. Drept de Returnare</h2>
              <p>Conform legislației în vigoare, aveți dreptul de a returna produsele în termen de 14 zile de la primire, cu excepția produselor personalizate sau unicat.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">7. Contact</h2>
              <p>Pentru întrebări sau reclamații, ne puteți contacta la: idaco_traditional@yahoo.com sau +40722.637.470</p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermeniConditii;
